









































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { DataModelOption } from '../interfaces/search-option'

@Component
export default class AppSelectorMulti extends Vue {
  @Prop({ type: Array }) readonly value!: number[]
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: '289' }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String }) readonly confirm!: string
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: Array }) readonly items!: string[] | DataModelOption[]

  model: string[] = []

  showPWD = false

  rules = {
    required: (value: string) => !!value || '不能为空！',
    text: () => true
  }

  searchInput = null

  get searchOptions () {
    const { items } = this
    if (typeof items[0] === 'string') {
      return items as string[]
    } else {
      return (items as DataModelOption[]).map((item) => item.value)
    }
  }

  mounted () {
    this.onItemsChanged()
  }

  remove (item: string) {
    const index = this.model.indexOf(item)
    if (index >= 0) this.model.splice(index, 1)
  }

  @Watch('model')
  onModelChanged () {
    this.valueChangedHandler()
  }

  @Watch('items')
  onItemsChanged () {
    const { items } = this

    if (!items.length) {
      return
    }
    this.model = this.value.map(idx => {
      const item = items[idx]
      return typeof item === 'string'
        ? item
        : item.value
    })
  }

  @Emit('input')
  valueChangedHandler () {
    const { items } = this

    if (!items.length) {
      return []
    }

    if (typeof items[0] === 'string') {
      return this.model.map(item => {
        return (items as string[]).findIndex(i => i === item)
      })
    } else {
      return this.model.map(item => {
        return (items as { id: number; value: string;}[]).findIndex(i => i.value === item)
      })
    }
  }
}
